import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Link } from 'react-router'

import './StoreResult.scss'

import Alert from '@argos/alert'
import ClickAndCollect from '../../ClickAndCollect/ClickAndCollect'
import OpeningHours from '../../OpeningHours/OpeningHours'

class StoreResult extends PureComponent {
  render () {
    const store = {...this.props}
    const toggleActive = event => this.props.toggleActive(event, store, store.order)
    const storeClass = classnames(
      'sc-store',
      'sc-store-' + store.id,
      'sc-store-type-' + store.type,
      { 'sc-store-active': store.active }
    )

    const iconClass = classnames(
      'argos-icon js-only',
      {'icon-UIE-Controls-Chevron-Down': !store.active},
      {'icon-UIE-Controls-Chevron-Up': store.active}
    )
    const getDay = new Date().getDay()
    return (
      <li className={storeClass} id={'sc-store-' + store.id} onClick={toggleActive} data-el={'sc-store-list-' + store.order}>
        <div className='sc-store-details'>
          <span className='sr-only'>Store order: {store.order + 1}</span>
          <span className='sc-store-icon sr-hidden' aria-hidden='true'>{store.order + 1}</span>
          <span className={iconClass} tabIndex='0' onClick={toggleActive} />
          <p className='sc-store-name'>{store.name}</p>
          <p className='sc-store-distance'><span className='sr-only'>Distance: </span><span aria-hidden='true'>(</span>{store.distance} miles<span aria-hidden='true'>)</span></p>
          { store.clickandcollect &&
            <ClickAndCollect />
          }
          { store.alert &&
            <div className='store-alert-push'>
              <Alert icon='error' backgroundColor='white' borderColor='red' textColor='red' hasBorder hasSVG>
                {store.alert.replace(/\u00a0/g, ' ')}
              </Alert>
            </div>
          }
          <span className='sr-only'>Address: </span>
          <p className='sc-store-address'>
            <span>{store.address}, {store.postcode}</span>
          </p>
          <p className='sc-store-todays-hours'>Open today from {store.storeTimes[getDay].time}</p>
          <div className='sc-more-info' aria-hidden={!store.active}>
            { store.active && store.tel !== '111111' &&
              <a href={'tel:' + store.tel.replace(/ /g, '')} className='sc-store-tel' onClick={(e) => { e.stopPropagation() }}><span className='sr-only'>Telephone number: </span> {store.tel}</a>
            }
            <hr />
            <OpeningHours hours={store.storeTimes} />
            <hr />
            <p>
              <Link to={store.permalink} className='link btn-moreinfo' onClick={(e) => { e.stopPropagation() }} tabIndex={store.active ? 0 : -1}>More info</Link>
            </p>
          </div>
          <noscript><p><Link to={store.permalink} className='link btn-moreinfo-nojavascript' onClick={(e) => { e.stopPropagation() }}>More info</Link></p></noscript>
        </div>
      </li>
    )
  }
}

StoreResult.propTypes = {
  toggleActive: PropTypes.func
}

export default StoreResult



// WEBPACK FOOTER //
// ./src/components/Results/StoreResult/StoreResult.jsx